import { z } from 'zod';

/**
 * 組み込みコールバックのスキーマ。
 *
 * 組み込みコールバックは業務ロジックに依存しないコールバック。
 *
 * - iframeの表示制御
 * - 処理終了時の通知
 *
 * を備えている。
 *
 * // TODO: 共通ライブラリにそのまま移せるはず。
 */
export const builtinCallbackSchema = z.object({
  /** モーダルを表示状態へと遷移させる命令。 */
  show: z.function(z.tuple([]).rest(z.unknown()), z.unknown()),
  /** モーダルを非表示状態へと遷移させる命令。 */
  hide: z.function(z.tuple([]).rest(z.unknown()), z.unknown()),
  /** モーダルを終了させ、メインページへ制御を返す命令。 */
  close: z.function(z.tuple([]).rest(z.unknown()), z.unknown()),
});

export const builtinCallbackDefinition = {
  schema: builtinCallbackSchema,
};
